import React from "react";
import InvoiceItem from "./InvoiceItem";
import { CurrencyIcon } from "../../modules/default-svg";
import { Receipt } from "lucide-react";

const AssociatedInvoices = ({ invoices, isLoading }) => {
  return (
    !isLoading && invoices && invoices.length > 0 && (
      <div className="risks-overview-container">
        <div className="d-flex align-items-center mb-3 risks-overview-header-container">
          <div className="mx-2"><Receipt strokeWidth={1.5} size={20} color="#342C82" /></div>
          <p className="text-md-600 text-primary all-risks" title="Invoices linked to this Purchase Order.">
            Associated Invoices
          </p>
          <span className="badge-label">{invoices.length}</span>
        </div>
        {invoices.map((invoice, index) => (
          <InvoiceItem key={index} item={invoice} />
        ))}
      </div>
    )
  );
};

export default AssociatedInvoices;
